import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import ContentLoader from 'react-content-loader';

import useConfigs from '../hooks/useConfigs';
import useThemes from '../hooks/useThemes';
import SaberMas from './Buttons/SaberMas';
import { useApi } from '../hooks/useApi';

// ##### Estilos #####
const ContServicios = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0;
  margin: 3rem 0px 17rem 0px;
  height: 70%;
  color: #444;
  background-color: ${(props) => props.background};

  -moz-background-size: cover;
  -webkit-background-size: cover;
  background-size: cover;
  -o-background-size: cover;
  z-index: 100;

  .service-desc {
    height: 180px;
    width: 100%;
  }

  h2 {
    color: var(--unnamed-color-ffffff);
    margin-top: 50px !important;
    font-size: 400%;
    padding-top: 20px !important;
  }

  h4 {
    color: var(--unnamed-color-ffffff);
    letter-spacing: 1px;
  }

  .panel {
    position: absolute;
    background: transparent;
    max-width: 20%;
    margin-top: -15rem;
    right: 0;
    z-index: 3;
  }

  @media (max-width: 1030px) {
    .panel {
      margin-top: -10rem;
      max-width: 30%;
    }
  }

  @media (max-width: 768px) {
    margin: 2rem 0px 17rem 0px;
    .panel {
      max-width: 33%;
      margin-top: -5rem;
    }
  }
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 20px;
  text-transform: initial;

  h2 {
    margin-top: 100px;
    font-size: ${(props) => 55 * props.fontsizemultiplier} !important;
    color: #fff;
    position: relative;
    margin-bottom: 15px;
    padding-bottom: 15px;
    text-transform: initial;
  }

  h4 {
    letter-spacing: 1px;
    color: #fff;
    font-size: ${(props) => 25 * props.fontsizemultiplier} !important;
  }
`;

const ServiceDesc = styled.div`
  padding: 0 1rem 2rem 1rem;

  img {
    max-width: 110%;
    height: 5000px;
  }

  h3 {
    font-size: ${(props) => 22 * props.fontsizemultiplier};
    font-weight: bold !important;
    color: ${(props) => props.colorprincipal};
    text-align: center;
    letter-spacing: 0px;
    opacity: 1;
  }

  p {
    color: ${(props) => props.colorsecundario};
    text-align: center;
    font-size: ${(props) => 15 * props.fontsizemultiplier};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp-: 3;
    overflow: hidden !important;
  }
`;

const CustomButton = styled.a`
  background-color: ${(props) => props.background};
  color: ${(props) => props.color};
  font-size: ${(props) => 16 * props.fontsizemultiplier};
  border: 1px solid;
  padding: 1rem 10rem;
  border-radius: 100px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
    filter: brightness(1.1);
    color: #fff;
  }
`;

const MotionDivCarousel = styled(motion.div)`
  cursor: grab;
  overflow: hidden !important;
  border-radius: 3px;
  margin: 2rem 0 5rem 0;
  position: relative;
  width: 100%;
`;

const MotionDivItems = styled(motion.div)`
  min-width: 30rem;
  width: 33%;
  margin: 0 10px;
  border-radius: 40px;

  img {
    pointer-events: none;
    width: 100%;
    height: 50% !important;
    border-radius: 40px 40px 397px 26px / 40px 40px 78px 28px;
    object-fit: cover;
  }
`;

const DivCardServices = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  box-shadow: 0 2px 0 rgb(90 97 105 / 11%), 0 4px 8px rgb(90 97 105 / 12%),
    0 10px 10px rgb(90 97 105 / 6%), 0 7px 70px rgb(90 97 105 / 10%);
  margin: 2rem auto;
  transition: 0.5s ease;
  min-width: 30rem;
  width: 33%;
  height: 100%;

  background-color: ${(props) => props.background};

  min-width: 30rem;
  min-height: 400px;
  margin: 0 10px;
  border-radius: 40px;
`;

export const Services = () => {
  const { fontSizeMultiplier } = useConfigs();
  const history = useHistory();
  const { push } = useHistory();
  const { banners, servicios, getBanners, getServicios } = useApi();

  const {
    imgLineas,
    backgroundWhite,
    backgroundSexto,
    backgroundSeptimo,
    colorPrincipal,
    colorSecundario,
    colorCuarto,
  } = useThemes();

  const [width, setWidth] = useState(0);
  const carousel = useRef();
  const carouselWidth = setTimeout(() => {
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, 3000);

  const handleClick = (item) => {
    if (item.nombreOpcion === 'Doctor famedic') {
      window.open(banners.data.doctorFamedic, '_blank');
    } else {
      // history.push(item.rutaOpcion);
      push({ pathname: '/servicio-detalle', state: item });
    }
  };

  useEffect(() => {
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, [carouselWidth]);

  useEffect(() => {
    getBanners();
    getServicios();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContServicios background={backgroundSexto} className='text-center'>
      <img className='panel' src={imgLineas} alt='lineas' />
      <div className='container'>
        <SectionTitle fontsizemultiplier={fontSizeMultiplier}>
          <h2>Servicios</h2>
          <h4>ACOMPAÑAMIENTO COMPLETO EN TUS PROCEDIMIENTO</h4>
        </SectionTitle>
      </div>
      <div className='fluid'>
        <MotionDivCarousel>
          <motion.div
            drag='x'
            dragConstraints={{ right: 0, left: -width - 50 }}
            whileTap={{ cursor: 'grabing' }}
            className='inner-carousel'
            ref={carousel}
          >
            {servicios.data ? (
              servicios.data.map(
                (d, i) =>
                  d?.activo && (
                    <MotionDivItems key={d.nombreOpcion + '-' + i}>
                      <DivCardServices background={backgroundSeptimo}>
                        <img src={d.imagen} alt='imagen' />
                        <ServiceDesc
                          fontsizemultiplier={fontSizeMultiplier}
                          colorprincipal={colorPrincipal}
                          colorsecundario={colorCuarto}
                        >
                          <h3>{d.nombreOpcion}</h3>
                          <p>{d.texto}</p>
                        </ServiceDesc>

                        <SaberMas
                          label='Saber más'
                          onClick={() => handleClick(d)}
                        />
                      </DivCardServices>
                    </MotionDivItems>
                  )
              )
            ) : (
              <ContentLoader
                speed={2}
                width='100%'
                height={560}
                foregroundColor='#05aaaa'
                backgroundColor='#f7f7f7'
              />
            )}
          </motion.div>
        </MotionDivCarousel>
      </div>
      <div>
        <CustomButton
          fontsizemultiplier={fontSizeMultiplier}
          color={backgroundWhite}
          background={colorSecundario}
          onClick={() => history.push('/services')}
        >
          Ver todo
        </CustomButton>
      </div>
    </ContServicios>
  );
};
